export enum TimerRoutes {
	CURRENT_TIMER = "/timer/",
	NEW_TIMER = "/timer/new/",
	PREVIOUS_TIMER = "/timer/previous",
}
